import { AxiosResponse } from 'axios';
import { useQuery, UseQueryResult } from 'react-query';
import { IContentsIntegrationResponse, IPostsIntegrationResponse, ITagsIntegrationResponse, LocalStorageKeysEnum } from '../pages/portal-pharmaceutical/common/contracts';
import { authenticatedGetRequest } from './authenticatedRequestService';

function getTags(): UseQueryResult<AxiosResponse<ITagsIntegrationResponse>, unknown> {
    const method = 'integration/get-tags';
    const query: any = {
        programCode: Number(process.env.REACT_APP_BOEHRINGER_PROGRAM_CODE),
        portalName: process.env.REACT_APP_PORTAL_NAME,
    };
    const staleTime = 60 * 10000;
    const cacheTime = 60 * 30000;

    return useQuery(
        [LocalStorageKeysEnum.GET_TAGS, JSON.stringify(query)],
        () => authenticatedGetRequest(method, undefined, query),
        {
            staleTime,
            cacheTime,
        },
    );
}

function getPosts(callApi: boolean, postDocumentId?: string): UseQueryResult<AxiosResponse<IPostsIntegrationResponse>, unknown> {
    const method = 'integration/get-posts';
    const query: any = {
        programCode: Number(process.env.REACT_APP_BOEHRINGER_PROGRAM_CODE),
        portalName: process.env.REACT_APP_PORTAL_NAME,
    };

    if (postDocumentId) {
        query.postDocumentId = postDocumentId;
    }

    const staleTime = 60 * 10000;
    const cacheTime = 60 * 30000;

    return useQuery(
        [LocalStorageKeysEnum.GET_POSTS, JSON.stringify(query)],
        () => authenticatedGetRequest(method, undefined, query),
        {
            enabled: callApi,
            staleTime,
            cacheTime,
        },
    );
}

function getContents(callApi: boolean, type?: string): UseQueryResult<AxiosResponse<IContentsIntegrationResponse>, unknown> {
    const method = 'integration/get-contents';
    const query: any = {
        programCode: Number(process.env.REACT_APP_BOEHRINGER_PROGRAM_CODE),
        portalName: process.env.REACT_APP_PORTAL_NAME,
    };

    if (type) {
        query.type = type;
    }

    const staleTime = 60 * 10000;
    const cacheTime = 60 * 30000;

    return useQuery(
        [LocalStorageKeysEnum.GET_CONTENTS, JSON.stringify(query)],
        () => authenticatedGetRequest(method, undefined, query),
        {
            enabled: callApi,
            staleTime,
            cacheTime,
        },
    );
}

export const contentsIntegrationService = {
    getTags,
    getPosts,
    getContents,
};
